import { useTicketTemplatesStore } from "@/store/ticketTemplates";

export function useHandleSocketTicketTemplateEvents() {
  const ticketTemplatesStore = useTicketTemplatesStore();

  return function handleSocketTicketTemplateEvents(): void {
    ticketTemplatesStore.all();
  };
}

export type SocketTicketTemplateEventsHandler = () => void;
